module.exports = __webpack_public_path__ + "img/taobao.ff9afd90.svg";